import React, { Component } from 'react';
import { InstantSearch, Configure, connectStateResults, connectInfiniteHits, connectCurrentRefinements } from 'react-instantsearch-dom';
import Event from '../components/Event';
import FilterToolbar from '../components/FilterToolbar';
import ByDayHits from '../components/ByDayHits';
import moment from '../utils/momentTimeZone'
import CalendarStripRefinement from '../components/CalendarStripRefinement'
import queryString from 'query-string';
import $ from 'jquery';


const $body = $('body')

const setBodyClassState = (isActive) => {
    if (isActive === true) {
        $body.addClass('state--whatson-showing-results');
    } else {
        $body.removeClass('state--whatson-showing-results')
    }
}

const isActiveSearch = (searchState) => {

    if(searchState) {

        if(searchState.query) {
            setBodyClassState(true)
            return true
        }
        if (searchState.refinementList) {
            for (const filter in searchState.refinementList) {
                if (searchState.refinementList[filter]) {
                    setBodyClassState(true)
                    return true
                }
            }
        }
        if (searchState.range) {
            for (const range in searchState.range) {
                const rangeValue = searchState.range[range]
                if (rangeValue && rangeValue.max) {
                    setBodyClassState(true)
                    return true
                }
            }
        }
    }

    setBodyClassState(false)
    return false
}


const InfiniteHits = connectInfiniteHits(({ hits, hasMore, refine }) => {
    return (
        <div>
            <div className="c-event-grid" aria-live="polite">
                {hits.map(hit =>
                    <Event key={hit.objectID} hit={hit} />
                )}
            </div>
            {hasMore && <div className="c-whats-on-LoadMore">
                <button className="c-btn c-btn--red c-btn--small" onClick={refine}>Show more</button>
            </div>}
        </div>
    )
})

const ClearAndFocus = connectCurrentRefinements(({ items, refine }) => {
    return (
        <div class="ais-ClearRefinements">
            <button
                className="ais-ClearRefinements-button"
                disabled={!items.length}
                onClick={() => {
                    refine(items);
                    const searchInput = document.querySelector('#event-search-input');
                    if (searchInput) searchInput.focus();
                }}
            >
            Clear
            </button>
        </div>
    );
});

const ByEventHits = connectStateResults(({ searchState, searchResults }) => {

    const { hits } = searchResults ? searchResults : {}

    const searchActive = isActiveSearch(searchState)

    if (hits && hits.length >= 0 && searchActive) {
        return (
            <div className="c-event-results" aria-live="polite">
                <div className="c-container c-container--flush">
                    <div className="c-search-description">
                        <h2 className="c-container-title">Results</h2>
                        <ClearAndFocus clearsQuery />
                    </div>

                    {hits.length === 0 && <div className="o-layout o-layout--center">
                        <div className="o-layout__item u-1/1@desktop">
                            <h4 className="fadeIn c-no-events-label" role="alert" aria-live="polite">There are no events that match your search criteria</h4>
                        </div>
                    </div>}

                    <InfiniteHits />

                </div>
            </div>
        )
    }
    return null

});

const saveStateToStorage = (key, state) => {
    sessionStorage.setItem(`globe-whatson-searchstate-${key}`, JSON.stringify(state))
}

class FilterView extends Component {

    constructor(props) {
        super(props)

        let defaultView = 'event';

        const urlParams = new URLSearchParams(window.location.search);
        this.dateStart = urlParams.get('date')
        this.eventTypes = urlParams.getAll('type')
        this.venues = urlParams.getAll('venues')
        this.access = urlParams.getAll('access')

        const hash = window.location.hash.replace('#', '')
        if (hash === 'event' || hash === 'day') {
            defaultView = hash
        }

        const parsed = queryString.parse(window.location.search)
        if (parsed) {
            this.filterQuery = parsed.filter
        }

        this.state = {
            view: defaultView,
            day: this.loadSavedStateFromStorage('day'),
            event: this.loadSavedStateFromStorage('event'),
        }

        this.construktFeatures = document.getElementById('construkt-features')

        if (this.access.length || this.eventTypes.length || this.venues.length)  {
            this.state.event.refinementList = this.state.event.refinementList || []
            this.state.event.refinementList['eventTypes'] = this.eventTypes
            this.state.event.refinementList['venues'] = this.venues
            this.state.event.refinementList['access'] = this.access
        }

        this.onSearchStateChange.bind(this)
    }

    loadSavedStateFromStorage = (key) => {
        const savedState = sessionStorage.getItem(`globe-whatson-searchstate-${key}`)
        let startofDay = moment().startOf('day')
        if (this.dateStart)  {
            startofDay = moment(this.dateStart, 'YYYY-MM-DD').startOf('day')
        }


        const defaultState = {
            event: {
                range: {
                    'instances.datetime': { min: moment().unix() },
                }
            },
            day: {
                range: {
                    'unixDay': { min: startofDay.unix(), max: startofDay.add(1, 'week').unix() }
                }
            }
        }

        if (key === 'event' && this.filterQuery) {
            defaultState.event = {
                ...defaultState.event,
                refinementList: {
                    'eventTypes': [
                        this.filterQuery
                    ]
                }
            }

            return defaultState.event
        }

        // If the date is set on the URL - use that date rather than the saved state
        if (this.dateStart && key === 'day')    {
            return defaultState[key]
        }
        if (savedState) {
            return JSON.parse(savedState)
        }
        return defaultState[key]
    }

    changeView(view) {
        this.setState({ view: view })

        if (view === 'event') {
            $body.removeClass('state--whatson-day').addClass('state--whatson-event');
        }
        if (view === 'day') {
            $body.removeClass('state--whatson-event').addClass('state--whatson-day');
        }
    }

    componentDidMount = () => {
        this.props.filterComponentHasMounted(true)
    }


    onSearchStateChange = searchState => {

        this.setState({ [this.state.view]: searchState });

        saveStateToStorage(this.state.view, searchState)

        if (this.construktFeatures) {
            this.construktFeatures.style.display = isActiveSearch(searchState) ? 'none' : 'block'
        }
    };

    render() {
        if(this.props.view === 'day') {
            if (this.construktFeatures) {
                this.construktFeatures.style.display = 'none'

            }
        } else if(this.props.view === 'event' && !isActiveSearch(this.state[this.props.view])) {
            if (this.construktFeatures) {
                this.construktFeatures.style.display = 'block'
            }
        }
        return (
            <React.Fragment>
                {this.state.view === 'event' && <InstantSearch
                    appId={window.WP_CONFIG.ALGOLIA_APPLICATION_ID}
                    apiKey={window.WP_CONFIG.ALGOLIA_SEARCH_API_KEY}
                    searchState={this.state.event}
                    indexName={window.WP_CONFIG.ALGOLIA_EVENTS_INDEX}
                    onSearchStateChange={this.onSearchStateChange}
                >
                    <Configure hitsPerPage={12} />
                    <div className="c-whats-on__viewtype">
                        <h2 className="u-hidden-visually">Whats On Filters</h2>
                        <ul >
                            <li className='active'>
                                <a href="#event" aria-current="page" onClick={() => { this.changeView('event') }}>
                                    <i className="fa-solid fa-grid" aria-hidden="true"></i>
                                    By Event
                                </a>
                            </li>
                            <li>
                                <a href="#day" onClick={() => { this.changeView('day') }}>
                                    <i className="fa-solid fa-calendar-alt" aria-hidden="true"></i>
                                    By Date
                                </a>
                            </li>
                        </ul>
                    </div>
                    <FilterToolbar />
                    <ByEventHits />
                </InstantSearch>}
                {this.state.view === 'day' && <InstantSearch
                    appId={window.WP_CONFIG.ALGOLIA_APPLICATION_ID}
                    apiKey={window.WP_CONFIG.ALGOLIA_SEARCH_API_KEY}
                    searchState={this.state.day}
                    indexName={window.WP_CONFIG.ALGOLIA_INSTANCES_INDEX}
                    onSearchStateChange={this.onSearchStateChange}
                >
                    <Configure hitsPerPage={999} />
                    <div className="c-whats-on__viewtype">
                        <h2 className="u-hidden-visually">Whats On Filters</h2>
                        <ul>
                            <li>
                                <a href="#event" onClick={() => { this.changeView('event') }}>
                                    <i className="fa-solid fa-grid" aria-hidden="true"></i>
                                    By Event
                                </a>
                            </li>
                            <li className='active'>
                                <a href="#day" aria-current="page" onClick={() => { this.changeView('day') }}>
                                    <i className="fa-solid fa-calendar-alt" aria-hidden="true"></i>
                                    By Date
                                </a>
                            </li>
                        </ul>
                    </div>
                    <CalendarStripRefinement searchState={this.state.day} attribute="unixDay" />
                    <section style={{zIndex: 1}}>
                        <ByDayHits dateRange={this.state.day} />
                    </section>
                </InstantSearch>}
            </React.Fragment>
        );
    }
}
export default FilterView;



// WEBPACK FOOTER //
// ./src/whatson/views/FilterView.js